import OrderedPageFilter from 'core/application/commons/orderedPageFilter'

import { parseZoneFormat } from 'common/dateFormatters'
import { formatMoney } from 'common/moneyFormatter'

export const employesColumns = (filter: OrderedPageFilter, onTerminatedUser: () => void, translate: any): any[] => {
  const columns = [
    {
      title: translate('prospect-signup.step-3.ein'),
      dataIndex: 'identifier',
      key: 'identifier',
      sorter: true,
    },
    {
      title: translate('prospect-signup.step-3.zip-code'),
      dataIndex: 'zipCode',
      key: 'zipCode',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: translate('prospect-signup.step-3.birth-date'),
      dataIndex: 'birthDate',
      key: 'birthDate',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      render: (text: string, record: any) => <span>{parseZoneFormat(record.birthDate)}</span>,
    },
    {
      title: translate('prospect-signup.step-3.annual-salary'),
      dataIndex: 'annualSalary',
      key: 'annualSalary',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      render: (text: string, record: any) => (
        <div>
          <span>{formatMoney(record.annualSalary)}</span> <br />
          <span className="color-gray-7 flex justify_center">{record.compensationMethod}</span>
        </div>
      ),
    },
    {
      title: translate('prospect-signup.step-3.status'),
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
    },

    {
      title: translate('prospect-signup.step-3.spouse'),
      dataIndex: 'isSpouse',
      key: 'isSpouse',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      render: (text: string, record: any) => <span>{record.isSpouse ? 'Yes' : 'No'}</span>,
    },
    {
      title: translate('prospect-signup.step-3.dependents'),
      dataIndex: 'hasDependents',
      key: 'hasDependents',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      render: (text: string, record: any) => <span>{record.hasDependents ? 'Yes' : 'No'}</span>,
    },
    {
      title: translate('prospect-signup.step-3.participating-ghp'),
      dataIndex: 'participatingGHP',
      key: 'participatingGHP',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      render: (text: string, record: any) => (
        <span>{record.participatingGHP != null ? (record.participatingGHP === true ? 'Yes' : 'No') : 'N/A'}</span>
      ),
    },
  ]

  const columnToSort: any = columns.find((c) => c.key === filter.orderColumn)
  columnToSort.defaultSortOrder = filter.orderDescending ? 'descend' : 'ascend'

  return columns
}
